import useDocumentTitle from '@/components/ui/common/document-title';
import FacilityAvailabilityCalendarView from './calendar';

const FacilityAvailability = () => {
  useDocumentTitle("Facility Availability");

  return (
    <div className="w-full h-full">
      <FacilityAvailabilityCalendarView />
    </div>
  );
}

export default FacilityAvailability;
